<template>
<div class="chapter">
<div class="inner_page">
<p class="p1"><span class="t1">By </span>A<span class="t3">SHLYN</span> K<span class="t3">ANE</span></p>
<p class="p0"><span class="t4">N</span><span class="t5">OVELS</span></p>
<p class="p0"><span class="t1">American Love Songs</span></p>
<p class="p0"><span class="t1">A Good Vintage</span></p>
<p class="p2"><span class="t1">W</span><span class="t6">ITH</span><span class="t1"> B</span><span class="t6">ETHANY</span><span class="t1"> B</span><span class="t6">ROWN</span></p>
<p class="p0"><span class="t1">L</span><span class="t6">OST</span><span class="t1"> B</span><span class="t6">OYS</span><span class="t1"> </span><span class="t6">AND</span><span class="t1"> L</span><span class="t6">OVE</span><span class="t1"> L</span><span class="t6">ETTERS</span><span class="t1"> S</span><span class="t6">ERIES</span></p>
<p class="p0"><span class="t1">True North</span></p>
<p class="p0"><span class="t1">Picture Perfect</span></p>
<p class="p0"><span class="t1">Wild Angels</span></p>
<p class="p0"><span class="t1">Broken Wings</span></p>
<p class="p2"><span class="t1">W</span><span class="t6">ITH</span><span class="t1"> M</span><span class="t6">ORGAN</span><span class="t1"> J</span><span class="t6">AMES</span></p>
<p class="p0"><span class="t1">Hair of the Dog</span></p>
<p class="p0"><span class="t1">Return to Sender</span></p>
<p class="p3"><span class="t1">Published by </span>D<span class="t3">REAMSPINNER</span> P<span class="t3">RESS</span></p>
<p class="p0"><span class="t1">http://www.dreamspinnerpress.com</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002.vue?69206c76